import { useDecision } from '@optimizely/react-sdk';
import { BodyText } from '@policygenius/mortar';
import { createUseStyles } from 'react-jss';

import Modal from 'components/Modal';

import { CONTENT, ELIGIBILITY_NOTE, NAME, NEW_CONTENT, NEW_TITLE, TITLE } from './constants';
import styles from './styles';

const useStyles = createUseStyles(styles);

const PregnancyModal = ({
  showModal,
  setShowModal,
}: {
  showModal: boolean;
  setShowModal(state: boolean): void;
}) => {
  const classes = useStyles();
  const closeModal = () => setShowModal(false);
  const [{ enabled: useUpdatedCopy }] = useDecision(
    'disability-consumer_release_pregnancy-warning-copy'
  );

  return (
    <Modal
      title={useUpdatedCopy ? NEW_TITLE : TITLE}
      primaryCTA={{ text: 'Got it', onClick: closeModal }}
      name={NAME}
      onRequestClose={closeModal}
      showModal={showModal}
    >
      {useUpdatedCopy ? (
        NEW_CONTENT.map((copy) => (
          <BodyText className={classes.content} key={copy} size="large">
            {copy}
          </BodyText>
        ))
      ) : (
        <>
          <BodyText size="large">{CONTENT}</BodyText>
          <br />
          <br />
          <BodyText size="large">
            <BodyText as="strong" size="inherit" weight="bold">
              Please note:{' '}
            </BodyText>
            {ELIGIBILITY_NOTE}
          </BodyText>
        </>
      )}
    </Modal>
  );
};

export default PregnancyModal;
